export const COMMENT_AND_FILE_MODE = {
    ADD: "add",
    EDIT: "edit",
};

export const FILE_UPLOAD_CONFIG = {
    MAX_SIZE_MB: 50,
    MAX_SIZE_BYTES: 50 * 1024 * 1024,
    ACCEPTED_TYPES: "application/pdf, image/jpeg, image/png, application/zip",
    UPLOADER_ID: "customer-comments-and-files-uploader",
};

export const COMMENT_TO_SHOW_MAX_LENGTH = 38;
